import React, { useEffect, useState } from "react";
import "../../../../style/calendar.scss";
import { DayPicker } from "react-day-picker";
import "react-day-picker/dist/style.css";
import "../style.scss";
import useLocaleByLanguage from "../../../../utils/hooks/useLocaleByLanguage";
import { useTranslation } from "react-i18next";
import addDays from "date-fns/addDays";
import { format } from "date-fns";

interface IProps {
  exerciseName: string;
  getExercisesByDate: (date: Date, zone: string) => void;
  selectedDate: Date;
  handleCloseModal?: (boolean: boolean) => void;
  listaDat?: Date[];
  defaultDate?: Date;
}
const CalendarDayPicker: React.FC<IProps> = ({
  getExercisesByDate,
  selectedDate,
  exerciseName,
  handleCloseModal,
  listaDat = [],
  defaultDate = new Date(),
}: IProps) => {
  const { t } = useTranslation();
  const locale = useLocaleByLanguage();
  const [month, setMonth] = useState<Date>(new Date());

  const disabledDays = listaDat.map((data) => data);

  const getDefaultMonth = (defaultDate: Date) => {
    if (format(defaultDate, "yyyy-MM-dd") !== format(new Date(), "yyyy-MM-dd")) {
      setMonth(defaultDate);
    }
  };

  useEffect(() => {
    getDefaultMonth(defaultDate);
  }, [defaultDate]);

  return (
    <React.Fragment>
      <div className="calendar">
        <DayPicker
          mode="single"
          locale={locale}
          selected={selectedDate}
          fromDate={new Date()}
          month={month}
          onMonthChange={setMonth}
          onSelect={(date) => {
            getExercisesByDate(date ?? new Date(), exerciseName);
            if (handleCloseModal) handleCloseModal(false);
          }}
          showOutsideDays
          modifiersClassNames={{
            selected: "my-selected",
            today: "my-today",
          }}
          disabled={[...disabledDays, { from: new Date(addDays(new Date(), 120)), to: new Date(2300, 4, 29) }]}
        />

        <div className="calendar-legend flex-center-center">
          <div className="calendar-legend-dot"></div>
          <b>{t("dostepne_terminy")}</b>
        </div>
      </div>
    </React.Fragment>
  );
};

export default CalendarDayPicker;
